import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { Card } from '@tcc/crate';
import HtmlText from 'html-text/HtmlText';

const baseString = 'vra-scripting-card';

const ScriptingCard = ({
  body,
  button,
  disabledMessageKey,
  icon,
  optionType,
  title,
  label
}) => {

  const classString = classNames({
    [`${baseString}`]: true,
    [`vra-${optionType}`]: true
  });

  const headerClassString = classNames({
    [`${baseString}__header`]: true,
    [`vra-${optionType}__header`]: true
  });

  const disabledMessage = disabledMessageKey ? <HtmlText messageKey={disabledMessageKey} /> : null;

  return (
    <Card className={classString}>
      <header className={headerClassString}>{title}{icon}{label}</header>
      <section className={`${baseString}__body`}>
        <p>{body}</p>
        <p className={`${baseString}__body__disabled-text`}>
          {disabledMessage}
        </p>
      </section>
      <footer className={`${baseString}__footer`}>
        {button}
      </footer>
    </Card>
  );
};

ScriptingCard.propTypes = {
  body:               propTypes.string,
  button:             propTypes.object,
  disabledMessageKey: propTypes.string,
  icon:               propTypes.object,
  optionType:         propTypes.oneOf(['advanced', 'manual']).isRequired,
  title:              propTypes.node,
  label:              propTypes.node
};

export default ScriptingCard;
